export default function TotalUSDTIcon(props: any) {
	return (
		<svg
			{...props}
			width={56}
			height={55}
			viewBox="0 0 56 55"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g filter="url(#filter0_d_2464_3070)">
				<g filter="url(#filter1_d_2464_3070)">
					<path
						d="M28.8174 12.0041C28.3901 11.9934 27.9628 12.004 27.5375 12.0321C24.7786 12.2129 22.1744 13.1041 19.8795 14.8306V13.9297C19.8776 13.399 19.4474 12.9688 18.9167 12.9669C18.3831 12.9649 17.9481 13.3961 17.9461 13.9297V16.9264C17.9461 17.7877 18.9843 18.2178 19.5943 17.6117C24.0594 13.1476 31.1267 12.6846 36.1351 16.5281C41.1434 20.3716 42.5238 27.3162 39.3686 32.7837C36.2115 38.2512 29.5105 40.5229 23.6775 38.1062C17.8446 35.6895 14.7155 29.3472 16.3502 23.2494C16.4894 22.7332 16.182 22.2025 15.6648 22.0652C15.1505 21.925 14.6198 22.2286 14.4787 22.7428C12.5975 29.7648 16.2197 37.1144 22.9351 39.8975C29.6506 42.6795 37.4053 40.0396 41.04 33.7465C44.6747 27.4534 43.0816 19.4175 37.3144 14.993C34.7914 13.0568 31.8063 12.0708 28.8174 12.0041ZM28.4858 16.6074C23.0328 16.6074 18.587 21.0463 18.587 26.4984C18.587 31.9504 23.0337 36.3952 28.4858 36.3952C33.9378 36.3952 38.3749 31.9495 38.3749 26.4984C38.3749 21.0473 33.9378 16.6074 28.4858 16.6074ZM28.4858 20.4248C29.0194 20.4267 29.4505 20.8617 29.4486 21.3953V21.5442C30.4153 21.6756 31.2437 22.275 31.6835 23.1092C31.931 23.5819 31.7483 24.1658 31.2746 24.4142C30.8039 24.6617 30.219 24.48 29.9696 24.0082C29.7966 23.6786 29.4621 23.4514 29.0484 23.4514H28.1494C27.5558 23.4514 27.1073 23.9 27.1073 24.4935C27.1073 25.087 27.5558 25.5356 28.1494 25.5356H28.4858H28.5332H28.8203C30.452 25.5356 31.788 26.8802 31.788 28.511C31.788 29.9272 30.7816 31.122 29.4486 31.4149V31.6073C29.4467 32.138 29.0165 32.5681 28.4858 32.5701C27.9512 32.573 27.5152 32.1418 27.5133 31.6073V31.4564C26.5486 31.323 25.7201 30.7276 25.2813 29.8953C25.0319 29.4235 25.2146 28.8368 25.6873 28.5883C26.1609 28.3389 26.7458 28.5226 26.9942 28.9963C27.1672 29.3259 27.5085 29.5511 27.9213 29.5511H28.8203C29.4148 29.5511 29.8546 29.1045 29.8546 28.511C29.8546 27.9175 29.4148 27.4689 28.8203 27.4689H28.4858H28.1494C26.5176 27.4689 25.174 26.1243 25.174 24.4935C25.174 23.0812 26.1832 21.8873 27.5133 21.5915V21.3953C27.5114 20.8578 27.9474 20.4219 28.4858 20.4248Z"
						fill="white"
					/>
				</g>
				<rect
					x="2.49097"
					y="0.5"
					width="51.984"
					height={52}
					rx="25.992"
					stroke="white"
					shapeRendering="crispEdges"
				/>
			</g>
			<defs>
				<filter
					id="filter0_d_2464_3070"
					x="0.990967"
					y={0}
					width="54.9839"
					height={55}
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy={1} />
					<feGaussianBlur stdDeviation="0.5" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
					/>
					<feBlend
						mode="normal"
						in2="BackgroundImageFix"
						result="effect1_dropShadow_2464_3070"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_2464_3070"
						result="shape"
					/>
				</filter>
				<filter
					id="filter1_d_2464_3070"
					x="12.9836"
					y={12}
					width="30.9985"
					height={31}
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy={1} />
					<feGaussianBlur stdDeviation="0.5" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
					/>
					<feBlend
						mode="normal"
						in2="BackgroundImageFix"
						result="effect1_dropShadow_2464_3070"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_2464_3070"
						result="shape"
					/>
				</filter>
			</defs>
		</svg>
	);
}
